const firebaseConfig = {
  apiKey: "AIzaSyDDMeUtntKUfRwA3UhKN4RmXwtNbKy-6Tc",
  authDomain: "helth-care-assignment-10.firebaseapp.com",
  projectId: "helth-care-assignment-10",
  storageBucket: "helth-care-assignment-10.appspot.com",
  messagingSenderId: "128479082514",
  appId: "1:128479082514:web:97b2f68a8b1debcbd600cb"
};
  export default firebaseConfig